<template>
  <v-container class="pa-0">

    <v-row>
      <v-col cols="12" md="6">
        <h1 style="
            font-family: Inter;
            font-weight: bold;
            color: #707070;
            line-height: 1;
            font-size: 1.8rem;
            text-align: left;
          ">
          Vade-mécum<span style="color: #f57029"> personalizado</span>
        </h1>
      </v-col>
      <v-col align="right" cols="12" md="6">
        <small v-if="(user.plano === `plano-free` || user.plano === null) && vademecum.length >= 3" class="mr-1"> Você atingiu o limite do seu
          plano, faça o <router-link style="color:#f57029" to="/painel/perfil"> upgrade </router-link>agora.</small>
        <v-btn :disabled="(user.plano === `plano-free`  || user.plano === null)  && vademecum.length >= 3" @click="showDialogAddVade = true"
          x-large color="#F15A24" dark><v-icon color="white">mdi-plus</v-icon>Novo Vade-mécum</v-btn>
      </v-col>
      <v-col>
        <v-card v-for="v in vademecum" :key="v.id" class="mb-1">
          <v-card-title style="cursor:pointer">
            <p @click="vademecumSeleceted = { ...v, edit: false }; showDialogVerLeis = true;" class="mb-0"> 
              <v-avatar  class="mr-1" size="25" :color="v.cor ? v.cor : `#f57029`">
            </v-avatar>
             {{ v.titulo ? v.titulo : ""}} 
             <small class="mx-1 grey--text">{{ v.leis.length }} Lei{{ v.leis.length > 1 ? `s` : ``}}
              <br> 
              <v-icon>{{ v.status === `public` ? `mdi-eye` : `mdi-eye-off` }}</v-icon>
              {{ translateVadeMecunStatus(v.status) }}</small>
            </p>
             <v-spacer></v-spacer>
              <v-btn class="d-flex justify-end" @click="excluirVadeMecum(v)" text>
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
          </v-card-title>
          <v-card-actions class="d-flex justify-start">

            <v-btn @click="vademecumSeleceted = { ...v, edit: false }; showDialogVerLeis = true;" text><v-icon>
                mdi-book-open-page-variant-outline</v-icon>
              Abrir Vade-Mécum</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-divider color="#f57029"></v-divider>

    <!-- <v-row style="padding: 60px 0">
      <v-col cols="12" md="12" >
        <h1
          style="
    font-family: Inter;
            font-weight: bold;
            color: #707070;
            line-height: 1;
            font-size: 1.8rem;
            text-align: left;
          "
        >
          mais <span style="color: #f57029"> recentes</span>
        </h1>
      </v-col>

      <v-col v-for="item in items" :key="item.id_lei" cols="6" md="2">
        <v-card style="padding: 5px !important; background-color: #f57029">
          <router-link
            :to="
              '/painel/lei/' +
              item.id_lei +
              '/' +
              sanitizeTitle(item.numero_lei)
            "
          >
            <v-list-item-title
              class="mb-3"
              style="white-space: initial; color: #fff !important"
            >
              <h3
                class="my-0 gt-bold"
                style="
                  font-size: 1rem !important;
                  letter-spacing: 1;
                  line-height: 1.2;
                "
              >
                {{ item.numero_lei }}
              </h3>
            </v-list-item-title>

            <v-list-item-subtitle
              style="font-size: 0.9rem !important; color: #fff"
              class="font-weight-light resumoNoticia"
            >
              <v-icon>mdi-calendar</v-icon>
              {{ item.data_lei | brdate }}</v-list-item-subtitle
            >
            <v-list-item-subtitle class="text--primary mb-4"
              >{{ item.nome_lei }}
            </v-list-item-subtitle>
          </router-link>
          <p>
            <label class="tag-sm mx-1" v-for="(t, i) in item.tags" :key="i">
              <input type="checkbox" disabled class="tag-sm-checkbox" />
              <span class="tag-sm-container">
                <span class="tag-sm-content">
                  <span>{{ t }}</span>
                  <span class="tag-sm-icon"></span>
                </span>
              </span>
            </label>
          </p>
        </v-card>
      </v-col>
    </v-row> -->
    <v-divider color="#cbc4bc" class="my-5"></v-divider>

    <!-- <v-row>
      <v-col cols="12" id="busca" md="6">
        <h1 style="
               font-family: Inter;
            font-weight: bold;
            color: #707070;
            line-height: 1;
            font-size: 1.8rem;
            text-align: left;
          ">
          Buscar por<span style="color: #f57029"> legislações</span>
          <small> ( {{
          totalFiltrado
        }}
            {{
            buscou && searchNoticia !== null ? " com: " + searchNoticia : ""
          }} )</small>
        </h1>
      </v-col>
      <v-col cols="12" md="6" align="right">
        Por página
        <v-btn-toggle v-model="perPageSelected" @change="resetPages = true">
          <v-btn>5</v-btn>
          <v-btn>10</v-btn>
          <v-btn>25</v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row> -->

    <!-- <v-row class="mx-1"
      style="position: sticky; top: 5px; margin-top:15px; border-radius:15px; background-color: rgb(255, 255, 255); z-index: 3; box-shadow: 0px 4px 7px -2px rgba(0,0,0,0.55);">

      <v-col cols="12" style="background-color: #fff;">
        <v-text-field v-model="searchNoticia" hide-details clearable color="#F15A24"
          :class="intBreakPoint <= 1 ? 'flex-column' : ''" class="mt-0 pt-0 justify-center align-center"
          placeholder="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)"
          label="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)"
          v-on:keyup.enter="buscou = true; resetPages = true; reloadLeis();">
          <template v-slot:append-outer>
            <v-btn outlined class="btn btn-primary mx-1" @click="
          buscou = true;
        resetPages = true;
        reloadLeis();
        ">
              <v-icon color="#F15A24">mdi-magnify</v-icon>

              Buscar
            </v-btn>
            <v-btn outlined v-if="order === 'DESC'" @click="
          order = 'ASC';
        resetPages = true;
        reloadLeis();
        " class="btn btn-secondary">
              <v-icon color="#F15A24">mdi-arrow-up</v-icon>

              Mais Antigas
            </v-btn>
            <v-btn outlined v-if="order === 'ASC'" @click="
          order = 'DESC';
        resetPages = true;
        reloadLeis();
        " class="btn btn-secondary">
              <v-icon color="#F15A24">mdi-arrow-down</v-icon>

              Mais Novas
            </v-btn>
          </template>
        </v-text-field>
      </v-col>
    </v-row> -->
    <!-- <v-row class="mt-5">
      <v-col cols="12">
        <label class="tag ma-1" v-for="(t, i) in allTags" :key="i">
          <input v-model="filterTags[i]" type="checkbox" class="tag-checkbox" />
          <span class="tag-container">
            <span class="tag-content">
              <span>{{ t }}</span>
              <span class="tag-icon"></span>
            </span>
          </span>
        </label>
      </v-col>
    </v-row> -->

    <div>

      <v-row>
        <v-col class="text-center" style="font-size:18px; ">
          Não encontrou a lei desejada? <v-btn style="font-size:18px; " @click="showDialogSugestao = true"
            outlined>Clique
            aqui</v-btn> que adicionaremos para você.
        </v-col>
      </v-row>
      <!-- <v-row class="mt-0 pt-0">
        <v-col cols="12" class="pt-0 d-flex align-center flex-column">
          <v-progress-circular v-if="loading" indeterminate class="my-orange mx-auto"></v-progress-circular>
          <v-list style="width: 100%" two-line>
            <v-list-item-group v-model="selected" active-class="my-orange">
              <v-list-item style="
                  border-top: 1px solid rgb(200 200 200);
                  margin: 8px 0px;
                  border-radius: 10px;
                " :class="intBreakPoint <= 1 ? 'flex-column' : ''" v-for="(item) in items" :key="item.id_lei">
                <v-list-item-content class="py-5">
                  <router-link :to="'/painel/lei/' +
          item.id_lei +
          '/' +
          sanitizeTitle(item.numero_lei)
          ">
                    <v-list-item-title class="mb-3" style="white-space: initial">
                      <h3 class="my-0 gt-bold d-flex justify-space-between">
                        <span class="my-orange ">{{ item.numero_lei }}</span>
                        <span class="text--primary text-subtitle-2 "><v-icon>mdi-calendar</v-icon>
                          {{ item.data_lei | brdate }}</span>
                      </h3>
                    </v-list-item-title>

                    <div class=" text--primary mb-4">{{ item.nome_lei }}
                    </div>
                  </router-link>
                  <v-list-item-subtitle style="display: flex; align-items: center;">
                    <v-text-field label="Apelido" type="text" v-if="item.apelidos_leis.length > 0"
                      v-model="item.apelidos_leis[0].apelido" :disabled="!item.disable ? true : false"
                      color="#F15A24"></v-text-field>

                    <v-btn v-if="!item.disable" out x-small outlined
                      @click=" item.apelidos_leis = item.apelidos_leis.length > 0 ? item.apelidos_leis : [{ apelido: `` }]; item.disable = true;"><v-icon
                        x-small>mdi-pencil</v-icon> Apelido</v-btn>
                    <v-btn v-if="item.disable" fab x-small outlined
                      @click="postNick(item.id_lei, item.apelidos_leis[0].apelido); item.disable = false;"
                      class="mr-1"><v-icon color="#F15A24">mdi-check</v-icon></v-btn>
                    <v-btn v-if="item.disable" fab x-small outlined
                      @click="item.disable = false"><v-icon>mdi-close</v-icon></v-btn>
                  </v-list-item-subtitle>
                  <p>
                    <label class="tag-sm mx-1" v-for="(t, i) in item.tags" :key="i">
                      <input type="checkbox" disabled class="tag-sm-checkbox" />
                      <span class="tag-sm-container">
                        <span class="tag-sm-content">
                          <span>{{ t }}</span>
                          <span class="tag-sm-icon"></span>
                        </span>
                      </span>
                    </label>
                  </p>
                  <p class="text-right">
                    <v-btn small @click="showDialogAddToVade = true; addTo = item" text class="px-0">
                      <v-icon color="#F15A24">mdi-plus</v-icon> Adicionar a Vade-mécum
                    </v-btn>
                  </p>
                </v-list-item-content>

              </v-list-item>

              <v-divider></v-divider>
            </v-list-item-group>
          </v-list>
        </v-col>
      </v-row> -->
      <!-- <v-row class="justify-center mb-10">
        <v-pagination color="#F15A24" v-model="page" v-if="qtdePage > 1" :length="qtdePage"
          :total-visible="15"></v-pagination>
      </v-row>
      <v-divider class="mb-5" color="#cbc4bc"></v-divider> -->

    </div>


    <v-snackbar v-model="snack.show">
      {{ snack.text }}
    </v-snackbar>

    <v-dialog width="500px" v-model="showDialogAddVade">
      <v-card>
        <v-card-title>Adicionar um novo vade-mécum</v-card-title>
        <v-card-text>
          <h3>Título</h3>
          <v-text-field color="#F15A24" v-model="newVadeMecum"></v-text-field>
          <h3>Cor</h3>
          <div>
            <v-color-picker class="mx-auto my-2" :swatches="swatches" v-model="newVadeMecumColor" hide-inputs
              show-swatches></v-color-picker>
          </div>
        </v-card-text>
        <v-card-actions class="text-center">
          <v-btn class="mx-auto" color="#F15A24" :loading="loadingNewVade" dark @click="postVadeMecum">Adicionar
            Vade-mécum</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="500px" v-model="showDialogAddToVade">
      <v-card>
        <v-card-title>Adicionar lei a um vade-mécum</v-card-title>
        <v-card-text>
          <h3>Selecione o vade-mécum</h3>
          <v-select :items="vademecum" item-value="id" item-text="titulo" color="#F15A24"
            v-model="addTo.vademecum"></v-select>
            <p v-if="vademecum.length == 0"> 
              Você ainda não criou um vade-mécum <v-btn @click="showDialogAddVade=true" style="color:#F15A24">Clique aqui</v-btn> e crie um agora.
            </p>
        </v-card-text>
        <v-card-actions class="text-center">
          <v-btn :disabled="vademecum.length === 0" color="#F15A24" class="mx-auto" dark @click="patchLeiToVadeMecum">Adicionar Vade-mécum</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog m width="850px" v-model="showDialogVerLeis">
      <v-card>
        <v-card-title class="d-flex justify-space-between flex-row">
          <div class="mb-0 d-flex flex-column align-start">
            <p class="mb-0 w-100 d-flex align-center">
              <v-menu :close-on-content-click="false">
                <template v-slot:activator="{ on: menu, attrs }">
                  <v-tooltip offset-y bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...menu }" :disabled="!vademecumSeleceted.edit"
                        dark>
                        <v-avatar size="28" :color="vademecumSeleceted.cor ? vademecumSeleceted.cor : `#f57029`"
                          class="mr-1">
                          <v-icon v-if="vademecumSeleceted.edit" small dark>mdi-refresh</v-icon>
                        </v-avatar>
                      </v-btn>
                    </template>
                    <span>Clique para trocar a cor</span>
                  </v-tooltip>
                </template>
                <v-card>
                  <v-card-text>
                    <v-color-picker class="mx-auto my-2" :swatches="swatches" v-model="vademecumSeleceted.cor"
                      hide-inputs show-swatches></v-color-picker>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn text>Fechar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
              <span>Legislações em</span>
              <input ref="edit" class="mx-2 pl-2"
                :style="{ color: vademecumSeleceted.cor ? vademecumSeleceted.cor : `#f57029` }"
                :size="vademecumSeleceted.titulo ? vademecumSeleceted.titulo.length - 3 : ``" color="#f57029"
                v-model="vademecumSeleceted.titulo" :disabled="!vademecumSeleceted.edit"
                :class="vademecumSeleceted.edit ? `borda-laranja` : ``" />
              <v-select  color="#f57029" v-model="vademecumSeleceted.status"
                style="max-width:130px"
                item-text="text" :disabled="!vademecumSeleceted.edit"
                
                :prepend-inner-icon="vademecumSeleceted.status === `public` ? `mdi-eye` : `mdi-eye-off`"
                item-value="id"
                :items="statusVadeMecun">
              </v-select>
            </p>
            <p class="mb-0">
              <span>
                <v-btn v-if="!vademecumSeleceted.edit" @click="editVD" text small>
                  <v-icon small color="#f57029">mdi-pencil</v-icon> Editar
                </v-btn>
                <v-btn v-if="vademecumSeleceted.edit" @click="editarVadeMecum()" :loading="savingVadeMecum" small text>
                  <v-icon small color="#f57029">mdi-check</v-icon> Salvar
                </v-btn>
                <v-btn v-if="vademecumSeleceted.edit" @click="vademecumSeleceted.edit = false" text small>
                  <v-icon small>mdi-close</v-icon> Cancelar
                </v-btn>
              </span>

            </p>


          </div>
          <v-btn @click="showDialogVerLeis = false; clearVadeMecumBusca()" icon>
            X
          </v-btn>
        </v-card-title>
        <v-card-text class="text-center">
          <v-btn @click="showDialogAddLeiToVade = true" outlined class="mx-auto"><v-icon color="#f57029">mdi-plus</v-icon>
                Adicionar legislação
              </v-btn>
          <v-text-field v-if="vademecumSeleceted.leis.length > 0" hide-details
            v-on:keyup.enter="searchConteudoVadeMecum" clearable v-model="buscaVadeMecum"
            @click:clear="clearVadeMecumBusca" @click:append="searchConteudoVadeMecum" outlined
            :append-icon="loadingSearch ? `mdi-loading` : `mdi-magnify`" color="#f57029"
            label="Pesquise por conteúdos nas legislações deste vade-mécum" class="my-4">

          </v-text-field>

          <v-expansion-panels>
            <v-expansion-panel v-if="vademecumSeleceted.leis.length === 0" class="d-flex align-center justify-center">
              <p class="mb-0 py-5">Este vade-mécum ainda não possui legislações. Adicione legislações clicando no botão
                abaixo.</p>
            </v-expansion-panel>
            <v-expansion-panel v-for="lei in vademecumSeleceted.leis" :key="lei.id"
              :disabled="lei.retornoBusca ? lei.retornoBusca.length === 0 : false">
              <v-expansion-panel-header class="d-flex justify-space-between">
                <p class="mb-0 d-flex flex-column align-start" style="width:100%">
                  <span>
                    {{ lei.leis_id_lei.numero_lei }}
                    <v-btn x-small text color="#f15a24" :to="'/painel/lei/' +
          lei.leis_id_lei.id_lei +
          '/' +
          sanitizeTitle(lei.leis_id_lei.numero_lei) +
          '/' + sanitizeTitle(vademecumSeleceted.titulo)
          ">
                      <v-icon color="#F15A24" x-small text>mdi-file-document</v-icon>
                      Ver Legislação
                    </v-btn>

                    <v-btn :loading="lei.deleting" x-small text color="#f15a24"
                      @click="excluirLeiVadeMecum(lei, vademecumSeleceted.id)">
                      <v-icon color="#F15A24" x-small text>mdi-delete</v-icon>
                      Excluir do Vade-mécum</v-btn>
                  </span> <br>
                  <small class="my-2">{{ lei.leis_id_lei.nome_lei }} </small>
                  <small style="width:100%" class="d-flex align-center" v-if="lei.leis_id_lei.apelidos_leis.length > 0">
                    <v-text-field hide-details="auto" label="Apelido" color="#F15A24" style="width:80%" dense outlined
                      :disabled="editNickVadeMecum != lei.leis_id_lei.apelidos_leis[0].id"
                      v-model="lei.leis_id_lei.apelidos_leis[0].apelido"></v-text-field>
                    <v-btn v-if="editNickVadeMecum != lei.leis_id_lei.apelidos_leis[0].id" text x-small
                      @click="editNickVadeMecum = lei.leis_id_lei.apelidos_leis[0].id">
                      <v-icon color="#F15A24" x-small text class="mr-1">mdi-pencil</v-icon> Editar apelido
                    </v-btn>
                    <v-btn @click="postNick(lei.leis_id_lei.id_lei, lei.leis_id_lei.apelidos_leis[0].apelido);"
                      v-if="editNickVadeMecum == lei.leis_id_lei.apelidos_leis[0].id" text x-small>
                      <v-icon color="#F15A24" x-small text class="mr-1">mdi-check</v-icon> Salvar
                    </v-btn>
                    <v-btn v-if="editNickVadeMecum == lei.leis_id_lei.apelidos_leis[0].id" text x-small
                      @click="editNickVadeMecum = 0">
                      <v-icon x-small text class="mr-1">mdi-close</v-icon> Cancelar
                    </v-btn>
                  </small>
                  <small v-if="lei.leis_id_lei.apelidos_leis.length == 0">
                    <v-btn
                      @click="lei.leis_id_lei.apelidos_leis = [{ id: 9999, apelido: `` }]; editNickVadeMecum = 9999"
                      text x-small v-if="lei.leis_id_lei.apelidos_leis.length === 0">
                      <v-icon color="#F15A24" x-small text class="mr-1">mdi-plus</v-icon> Criar apelido
                    </v-btn>
                  </small>
                  <v-divider class="my-3" style="width:100%"></v-divider>
                  <small v-if="lei.retornoBusca ? lei.retornoBusca.length > 0 : false">
                    <b>{{ lei.retornoBusca ? lei.retornoBusca.length : `` }}</b> resultados para <i class="my-orange">{{
          buscaVadeMecum }}</i>
                  </small>
                </p>


              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <p v-for="c in lei.retornoBusca" :key="`vd${c.id_reg}`">
                  <span v-html="highlight(c.conteudo, buscaVadeMecum)"></span>
                  <v-btn text small class="mx-1 opacity-75"
                    :to="`/painel/lei/${lei.leis_id_lei.id_lei}/${sanitizeTitle(lei.leis_id_lei.numero_lei)}?id=${c.id_reg}`">
                    <v-icon color="#f57029">mdi-arrow-right-top</v-icon> Ir até o conteudo
                  </v-btn>
                </p>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">

        </v-card-actions>
      </v-card>

    </v-dialog>
    <v-dialog width="850px" v-model="showDialogAddLeiToVade">
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <p class="mb-0">Adicionar legislação em <span style="color: #f57029">{{ vademecumSeleceted.titulo }}</span>
          </p>
          <v-btn @click="showDialogAddLeiToVade = false; clearInternalSearch()" icon>
            X
          </v-btn>
          <v-card-text>
            <v-text-field v-on:keyup.enter="searchLeisInVadeMecum" :disable="loadingInternalSearch" clearable
              v-model="searchAddLeis" @click:clear="clearInternalSearch" @click:append="searchLeisInVadeMecum"
              :append-icon="loadingSearch ? `mdi-loading` : `mdi-magnify`" color="#f57029" hide-details outlined
              placeholder="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)"
              label="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)" />
            <v-list>

              <v-list-item class="px-0 text-center d-flex justify-center" v-if="loadingInternalSearch">
                <v-progress-circular indeterminate>
                </v-progress-circular>
              </v-list-item>
              <v-list-item class="px-0 text-center d-flex justify-center"
                v-if="internalLeisSearch.length === 0 && !loadingInternalSearch">
                <p>Utilize o campo acima para encontrar legislações.</p>
              </v-list-item>
              <v-hover v-slot="{ hover }" v-for="item in internalLeisSearch" :key="item.id_lei" >
                <v-list-item  :class="hover ? `bkgHover` : ``" style="border-top:1px solid #f57029; border-radius:10px" class=" mb-5">
                  <v-list-item-content>
                    <v-list-item-title v-html="highlight(item.numero_lei, searchAddLeis)">
                    </v-list-item-title>
                    <div><small v-html="highlight(item.nome_lei, searchAddLeis)"></small></div>
                  </v-list-item-content>
                  <v-list-item-action  class="text-center">
                    <span class="text-subtitle " style="min-width:90px; text-transform: uppercase;"
                      v-if="vademecumSeleceted.leis.find(e => parseInt(e.leis_id_lei.id_lei) === item.id_lei)">Adicionado</span>
                    <v-btn v-else small text color="#F15A24" :loading="item.loading"
                      @click="addLeiToVade(item, vademecumSeleceted.id)">Adicionar</v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-hover>
            </v-list>
          </v-card-text>
        </v-card-title>
      </v-card>
    </v-dialog>
    <v-dialog width="580px" v-model="showDialogSugestao">
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <p class="mb-0">Enviar um sugestão</p>
          <v-btn @click="showDialogSugestao = false;" icon>
            X
          </v-btn>
          <v-card-text>
            <v-textarea clearable v-model="txtSugestao" color="#F15A24" placeholder="Escreva aqui a sua sugestão" />

          </v-card-text>
        </v-card-title>
        <v-card-actions class="d-flex justify-center"><v-btn @click="sendSugestion" color="#F15A24"
            style="color:white">Enviar</v-btn></v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<style scoped>
.borda-laranja {
  border: 1px solid #F15A24;
  border-radius: 20px;
  padding: 3px;
}

.boxText {
  background-color: #F15A24;
  padding: 5px 15px;
  color: white;
  width: 185px;
  height: 42px;
  font-size: 22px;
}


a {
  text-decoration: none;
}

a:hover h2,
a:hover p {
  text-decoration: underline;
}

.resumoNoticia {
  font-size: 1.1rem !important;
  white-space: initial;
}

.highlightText {
  color: red
}
.bkgHover { 
  background-color:rgba(0, 0, 0, 0.08) !important
}
</style>

<script>
//import BtnCompartilhar from "../components/BtnCompartilahr.vue";
export default {
  name: "Legislacoes",
  //components: { BtnCompartilhar },
  data() {
    return {
      // nick: '',
      // nicks: [],
      editNickVadeMecum: 0,
      editing: [],
      showDialogVerLeis: false,
      showDialogAddLeiToVade: false,
      vademecumSeleceted: { leis: [], edit: false },
      statusVadeMecun: [ 
        { id: 'published', text: 'Privado'},
        {id: "public", text:"Público"}
      ],
      vademecum: [],
      addTo: {},
      showDialogAddVade: false,
      first: false,
      showDialogAddToVade: false,
      loadingNewVade: false,
      loadingNewNick: false,
      disable: true,
      newVadeMecum: '',
      newVadeMecumColor: "",
      page: 1,
      perPageSelected: 0,
      perPage: [5, 10, 25],
      order: "ASC",
      searchNoticia: null,
      buscou: false,
      resetPages: false,
      loading: true,
      selected: [],
      noticiasDestaque: [],
      items: [],
      searchAddLeis: "",
      patchLoading: [],
      internalLeisSearch: [],
      imgs: [],
      totalItems: 0,
      totalFiltrado: 0,
      loadingInternalSearch: false,
      loadingSearch: false,
      filterTags: [],
      allTags: [],
      swatches: [
        ['#FF0000', '#AA0000', '#550000'],
        ['#FFFF00', '#AAAA00', '#555500'],
        ['#00FF00', '#00AA00', '#005500'],
        ['#00FFFF', '#00AAAA', '#005555'],
        ['#0000FF', '#0000AA', '#000055'],
      ],
      snack: {
        show: false,
        text: "Favoritado com sucesso",
      },
      resultadoBusca: [],
      buscaVadeMecum: "",
      savingVadeMecum: false,
      showDialogSugestao: false,
      txtSugestao: ""
    };
  },
  created() {
    this.loading = true;
    this.reloadLeis();
    this.reloadVadeMecum();
    // this.reloadLeisGraphQl()
  },
  methods: {
    translateVadeMecunStatus(status) { 
      switch(status) { 
        case "published": 
          return "Privado"
        case "public": 
          return "Público"
        default: 
          return "Privado"  
      }
    },
    sendSugestion() {
      this.$http.post("/items/suporte", {
        mensagem: this.txtSugestao
      }).then(() => {
        this.txtSugestao = ""
        this.showDialogSugestao = false
        alert("Obrigado por nos enviar sua sugestão, retornaremos o mais breve possível.")
      })
    },
    excluirLeiVadeMecum(rel, idVadeMecum) {
      rel.deleting = true
      this.$http
        .patch("/items/vademecums/" + idVadeMecum, {
          leis: { delete: [rel.id] }
        })
        .then(() => {
          //  window.console.log(res.status)
          this.reloadVadeMecum(idVadeMecum)
          rel.deleting = false

        })
    },
    editVD() {
      this.vademecumSeleceted.edit = true;
      this.$refs.edit.focus()
      // window.console.log(this.$refs.edit)
    },
    editarVadeMecum() {
      this.savingVadeMecum = true
      this.$http
        .patch("/items/vademecums/" + this.vademecumSeleceted.id, {
          titulo: this.vademecumSeleceted.titulo,
          cor: this.vademecumSeleceted.cor,
          status: this.vademecumSeleceted.status
        })
        .then(() => {
          this.savingVadeMecum = false
          this.vademecumSeleceted.edit = false
          this.reloadVadeMecum()
        });
    },
    excluirVadeMecum(v) {
      if (confirm(`Você deseja excluir o vade-mécum ${v.titulo ? v.titulo : ""} ?`)) {
        this.$http
          .patch("/items/vademecums/" + v.id, {
            status: 'archived'
          })
          .then(() => {
            this.reloadVadeMecum()
          });
      }
    },
    clearVadeMecumBusca() {
      this.vademecumSeleceted.leis.forEach(lei => {
        lei.retornoBusca = undefined
      })
      this.buscaVadeMecum = ""

      this.$forceUpdate()
    },

    clearInternalSearch() {
      this.internalLeisSearch = []
      this.searchAddLeis = ""
    },

    async reloadVadeMecum(idVadeMecum) {
      const query = `query FilterVadeMecumsByApelidosLeis($user_id:String){
          vademecums(sort: ["-date_created"], filter: { status: {_in : ["published", "public"] }, user_created: { id: { _eq: $user_id}}}) {
            id
            titulo
            status
            cor
            leis {
              id
              leis_id_lei { 
                id_lei
                numero_lei
                data_lei  
                nome_lei
                apelidos_leis (sort:["-date_created"], filter: { user_created: { id: { _eq: $user_id}}}){
                    id
                    apelido
                }
              }
            }
          }
      }`

      const variables = { user_id: this.user.id };
      const {
        data: { data },
      } = await this.$http.post("/graphql", {
        query,
        variables,
      });
      this.vademecum = data.vademecums;
      if (idVadeMecum) {
        this.vademecumSeleceted = this.vademecum.filter((e) => e.id == idVadeMecum)[0]
      }
    },
    patchLeiToVadeMecum() {
      this.loadingNewVade = true
      // this.addTo.items.push(this.addTo.id)
      this.$http
        .patch("/items/vademecums/" + this.addTo.vademecum, {
          leis: { create: [{ leis_id_lei: { id_lei: this.addTo.id_lei }, vademecums_id: this.addTo.vademecum }] }
        })
        .then(() => {
          this.loadingNewVade = false
          this.showDialogAddToVade = false
          this.newVadeMecum = ""
          // window.console.log(res);
          this.reloadVadeMecum(this.addTo.vademecum)
        });
    },
    postVadeMecum() {
      this.loadingNewVade = true
      this.$http
        .post("/items/vademecums", {
          titulo: this.newVadeMecum,
          cor: this.newVadeMecumColor,
          status: "published"
        })
        .then(() => {
          this.loadingNewVade = false
          this.showDialogAddVade = false
          this.newVadeMecum = ""
          this.newVadeMecumColor = ""
          // window.console.log(res);
          this.reloadVadeMecum()
        });
    },
    makeFavorite(lei) {
      this.$http
        .post("/items/favoritos", {
          id_lei: lei.id_lei,
          observacao: "",
        })
        .then((res) => {
          this.snack.show = true;
          window.console.log(res);
        });
    },
    searchLeisInVadeMecum() {
      // window.console.log(isNaN(this.searchAddLeis))
      if (!isNaN(this.searchAddLeis) && (this.searchAddLeis.indexOf(".") == -1)) {
        this.searchAddLeis = this.searchAddLeis.replace(/(\d)(?=(\d{3})+$)/g, '$1.');
      }
      let search =
        this.searchAddLeis === undefined || this.searchAddLeis === null ? "" :
        `filter={
          "_or": [
            {"numero_lei": { "_contains": "${this.searchAddLeis}"}},
            {"nome_lei": {"_contains": "${this.searchAddLeis}"}}
          ]
        }`;
      // let sort = `&sort=-data_lei`;
      let sort = ``;
      let limit = "&limit=-1"

      this.loadingInternalSearch = true
      this.internalLeisSearch = [];
      this.$http({
        url: "items/leis?fields=*&" + search + sort + limit,
      }).then(
        (data) => {
          this.internalLeisSearch = data.data.data;
          this.loadingInternalSearch = false
          // this.concatTags();
          // window.console.log(this.items);

        },
        () => {
          // window.console.log(err);
        }
      );
    },
    // async reloadApelidos() {
    //   const ids = this.items.map(e => e.id_lei)

    //   const {
    //     data: { data },
    //   } = await this.$http.get(`/items/apelidos_leis?filter[lei][_in]=${ids}&filter[user_created][_eq]=${this.user.id}`);
    //   window.console.log({ids, data})

    // },
    async reloadLeisGraphQl() {
      this.loading = true;
      if ((this.searchNoticia !== null) && !isNaN(this.searchNoticia) && (this.searchNoticia.indexOf(".") == -1)) {
        this.searchNoticia = this.searchNoticia.replace(/(\d)(?=(\d{3})+$)/g, '$1.');
      }
      let search =
        this.searchNoticia === undefined || this.searchNoticia === null ? "" : `search:"${this.searchNoticia}",`;
      const query = `query FilterByApelidosLeis($user_id:String){
          leis(${search} sort:["${this.order === "ASC" ? "-" : ""}data_lei"],
                limit: ${this.perPage[this.perPageSelected]}, 
                offset: ${(this.page - 1) * this.perPage[this.perPageSelected]}) {
            id_lei
            numero_lei
            data_lei  
            nome_lei
            apelidos_leis (filter: { user_created: { id: { _eq: $user_id}}}){
                apelido
            }
          }
          leis_aggregated${search === "" ? `` : `(${search})`} {
            count { id_lei }
          }
      }`
      const variables = { user_id: this.user.id };
      const {
        data: { data },
      } = await this.$http.post("/graphql", {
        query,
        variables,
      });
      // window.console.log(data)
      // this.totalItems = data.data.meta.total_count;
      this.totalFiltrado = data.leis_aggregated[0].count.id_lei;
      this.loading = false;
      if (this.resetPages) {
        this.page = 1;
        this.resetPages = false;
      }
      this.items = data.leis;

      if (this.first) {
        document.querySelector("#busca").scrollIntoView({ behavior: `smooth` })

      }
      else {
        this.first = true
      }

    },
    reloadLeis() {
      this.reloadLeisGraphQl()
      return

    },
    oldReloadLeis() {
      let search =
        this.searchNoticia === undefined || this.searchNoticia === null ? "" : "search=" + this.searchNoticia;
      let sort = `&sort=${this.order === "ASC" ? "-" : ""}data_lei`;
      let limit = "&limit=" + this.perPage[this.perPageSelected];
      let offset =
        "&offset=" + (this.page - 1) * this.perPage[this.perPageSelected];
      // let filter = "&filter[apelidos_leis][user_created][id][_eq]="+ this.user.id;
      let filter = ""
      // let filters = []
      // this.filterTags.forEach((el,i) => {
      //   if (el) {
      //     filters.push(this.allTags[i])
      //   }
      // })
      // let filter1 = filters.length === 0 ? "" : "&filter[tags][_contains]="+filters.join()
      let meta = "&meta=total_count,filter_count";

      this.loading = true;
      this.items = [];
      this.$http({
        url: "items/leis?fields=id_lei,nome_lei,data_lei,numero_lei&" + filter + search + sort + limit + offset + meta,
      }).then(
        (data) => {
          this.items = data.data.data;
          // this.totalItems = data.data.meta.total_count;
          this.totalFiltrado = data.data.meta.filter_count;
          this.loading = false;
          if (this.resetPages) {
            this.page = 1;
            this.resetPages = false;
          }
          // this.reloadApelidos()
          //this.concatTags();
          //window.console.log(this.items);
        },
        (err) => {
          window.console.log(err);
        }
      );
    },
    loadFeaturedImage() {
      let noticiasDestaqueLength = this.noticiasDestaque.length;
      this.noticiasDestaque.forEach((p, i) => {
        if (p.imagem.id != null) {
          this.$http({
            url: "assets/" + p.imagem.id,
            responseType: "blob",
          }).then((response) => {
            let reader = new FileReader();
            reader.readAsDataURL(response.data);
            reader.onload = () => {
              this.imgs[p.imagem.id] = reader.result;
              i + 1 === noticiasDestaqueLength ? this.$forceUpdate() : "";
            };
          });
        }
      });
    },
    requireImg(img) {
      return require("../assets/" + img);
    },
    concatTags() {
      this.items.forEach((el) => {
        if (el.tags != null) {
          this.allTags.push(...el.tags);
        }
      });

      this.allTags = this.allTags.filter((item, index) => {
        return this.allTags.indexOf(item) == index;
      });
    },

    sanitizeTitle(title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
    searchConteudoVadeMecum() {
      if (this.buscaVadeMecum === "") return
      this.loadingSearch = true
      this.$http.get(`items/conteudoleis/?search=${this.buscaVadeMecum}&limit=-1&filter[id_lei][_in]=${this.vademecumSeleceted.leis.map((e) => e.leis_id_lei.id_lei).toString()}`).then(res => {
        let resultadoBusca = []
        res.data.data.forEach(el => {
          if (resultadoBusca[el.id_lei] === undefined) resultadoBusca[el.id_lei] = []
          resultadoBusca[el.id_lei].push(el)
        })
        this.vademecumSeleceted.leis.forEach(lei => {
          if (resultadoBusca[lei.leis_id_lei.id_lei] === undefined) resultadoBusca[lei.leis_id_lei.id_lei] = []
          lei.retornoBusca = resultadoBusca[lei.leis_id_lei.id_lei]
        })
        this.loadingSearch = false
        this.$forceUpdate()
      })
    },
    highlight(content, query) {
      if (!query) {
        return content;
      }
      return content.replace(new RegExp(query, "gi"), match => {
        return '<span class="my-orange">' + match + '</span>';
      });
    },
    postNick(idLei, nick) {
      this.$http.post(`items/apelidos_leis`, {
        status: 'Publicado',
        lei: idLei,
        apelido: nick,
      }).then((res) => {
        window.console.log(res)
        this.editNickVadeMecum = 0
      })
    },

    addLeiToVade(lei, vadeMecum) {
      lei.loading = true
      window.console.log(lei)

      // this.addTo.items.push(this.addTo.id)
      this.$http
        .patch("/items/vademecums/" + vadeMecum, {
          leis: { create: [{ leis_id_lei: { id_lei: lei.id_lei }, vademecums_id: vadeMecum }] }
        })
        .then(() => {
          lei.loading = false
          this.showDialogAddLeiToVade = false
          this.searchAddLeis = ""
          // window.console.log(res);
          this.reloadVadeMecum(vadeMecum)
        });
    }
  },

  computed: {
    user() {
      return this.$store.state.user
    },
    qtdePage() {
      return Math.ceil(this.totalFiltrado / this.perPage[this.perPageSelected]);
    },
    intBreakPoint() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 0;
        case "sm":
          return 1;
        case "md":
          return 2;
        case "lg":
          return 3;
        case "xl":
          return 4;
        default:
          return 0;
      }
    },

  },
  watch: {
    '$route.params.strFiltro': {
      handler: function (search) {
        if (search) {
          this.searchNoticia = search
          this.reloadLeis()
        }
      },
      deep: true,
      immediate: true
    },
    showDialogAddLeiToVade(oldValue, newValue) {
      if (newValue == false ) { 
        this.clearInternalSearch()
      }
    },
    page(oldValue, newValue) {
      if (oldValue != newValue) {
        this.reloadLeis();
      }
    },
    perPageSelected() {
      this.reloadLeis();
    },
    filterTags: {
      handler() {
        this.reloadLeis();
      },
      deep: true,
    },
    searchNoticia(newValue) {
      if (newValue === null) {
        this.buscou = false;
        this.reloadLeis();
      }
    },

  },
};
</script>
